import { Locale, LocalCode } from "../../store/i18n/types";

/*
The language the user picks on the auth screens (or from the header menu) is a
session preference: it is kept in localStorage so it survives a page refresh and
the CLEAR_ALL dispatched by SessionManager.login, and it is dropped on logout.
It never reaches the backend, so the account locale (CustomUser.locale) is left
untouched.
*/

const SESSION_LANGUAGE_KEY = 'sessionLanguage';

export const LANGUAGES: {name: string, value: LocalCode}[] = [
    { name: 'Español', value: 'ES' },
    { name: 'English', value: 'EN' },
    { name: 'Português', value: 'PT' },
    { name: 'Français', value: 'FR' },
];

// Locale used when the selected language differs from the account one, so there
// is no country to preserve.
const DEFAULT_LOCALES: {[key in LocalCode]: Locale} = {
    ES: 'es-ES',
    EN: 'en-US',
    PT: 'pt-BR',
    FR: 'fr-FR'
};

export function getSessionLanguage(): LocalCode | null {

    let stored = localStorage.getItem(SESSION_LANGUAGE_KEY);

    if (LANGUAGES.some(lang => lang.value === stored)) {
        return stored as LocalCode;
    }
    return null;
}

export function setSessionLanguage(code: LocalCode) {
    localStorage.setItem(SESSION_LANGUAGE_KEY, code);
}

export function clearSessionLanguage() {
    localStorage.removeItem(SESSION_LANGUAGE_KEY);
}

export function localCodeFromLocale(locale: Locale): LocalCode {

    if (locale.startsWith('es-')) return 'ES';
    if (locale.startsWith('pt-')) return 'PT';
    if (locale.startsWith('fr-')) return 'FR';
    return 'EN';
}

/*
Keep the account locale when the user is not actually switching language, so the
country specific CMS content is preserved (es-AR stays es-AR instead of becoming
es-ES).
*/
export function resolveLocale(code: LocalCode, accountLocale: Locale): Locale {

    if (localCodeFromLocale(accountLocale) === code) {
        return accountLocale;
    }
    return DEFAULT_LOCALES[code];
}
